import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog';
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions';
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent';
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import FormatQuote from 'housecall-ui/dist/IconsAndImages/Icons/FormatQuote';

import { closePayWall, PAY_WALL_CONFIRMATION_TEXT } from 'components/PayWall/Redux/Actions';
import { PayWallFullState } from 'components/PayWall/Redux/Reducer.type';

const useStyles = makeStyles((theme) => ({
  reviewLeft: {
    marginLeft: 8,
    marginTop: 8,
    marginBotton: 5,
    marginRight: 8,
    width: 5,
    background: theme.palette.primary.main,
  },
  reviewText: {
    fontSize: 14,
    color: theme.palette.secondary.main,
  },
  icon: {
    color: theme.palette.primary.main,
  },
}));

export default function PayWallConfirmDialog(): JSX.Element {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { parent } = window;
  const confirmDialogOpen = useSelector((state: PayWallFullState) => state.payWall.confirmDialogOpen);

  function toggleConfirmDialog(isOpen: boolean) {
    dispatch({ type: PAY_WALL_CONFIRMATION_TEXT, status: isOpen });
  }

  const cancelDialog = () => {
    dispatch(closePayWall());
    parent.postMessage('closeDialog', '*');
  };

  return (
    <Dialog open={confirmDialogOpen ?? false} maxWidth="md" onClose={() => toggleConfirmDialog(false)}>
      <DialogTitle>Did you mean to hit cancel?</DialogTitle>
      <DialogContent>
        <Typography type="body1">
          On average, Housecall Pro users grow their business 37% in their first year. Sign up for a premium plan to
          take advantage of all the features Housecall Pro has to offer. Don&apos;t just take our word for it:
        </Typography>
        <div style={{ height: 30 }} />
        <Grid container>
          <div className={classes.reviewLeft} />
          <Grid item xs={10}>
            <Typography className={classes.reviewText}>
              Housecall Pro is equivalent to hiring several office staff. We can&apos;t imagine how we ran our business
              without it. These guys really understand the needs of our business.
            </Typography>
          </Grid>
          <Grid item style={{ marginTop: -20 }}>
            <FormatQuote classes={{ root: classes.icon }} />
          </Grid>
        </Grid>
        <div style={{ height: 30 }} />
        <Typography className={classes.reviewText}>GARRY DAVIS, ORO VALLEY ELECTRIC</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancelDialog}>I still want to cancel</Button>
        <Button color="primary" onClick={() => toggleConfirmDialog(false)}>
          Choose a plan
        </Button>
      </DialogActions>
    </Dialog>
  );
}
